import { MouseEvent, ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Typography, tokens, TypographyProps } from '@cast/design-system';

type InventoryWorkloadNameLinkProps = {
  to: string;
  children: ReactNode;
  variant?: TypographyProps['variant'];
  onClick?: (event: MouseEvent<HTMLAnchorElement>) => void;
};

export const InventoryWorkloadNameLink = ({
  to,
  children,
  variant = 'P12M',
  onClick,
}: InventoryWorkloadNameLinkProps) => (
  <Typography
    component={RouterLink}
    to={to}
    variant={variant}
    color={tokens.theme.fg.action.primary}
    noWrap
    onClick={(event) => {
      event.stopPropagation();
      onClick?.(event);
    }}
    sx={{
      textDecoration: 'none',
      '&:hover': { textDecoration: 'underline' },
    }}
  >
    {children}
  </Typography>
);
